import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Modal,
  IconButton,
  Avatar,
  CircularProgress,
  Chip,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slider from "react-slick";
import { BASEURL } from "../../../constant/constant";

// Styled components for complex CSS properties
const BannerBox = styled(Box)(({ theme }) => ({
  background: `url(${BASEURL}/images/banner.png) no-repeat center center`,
  backgroundSize: "cover",
  height: 500,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  position: "relative",
  borderBottom: "5px solid #ffd700",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(10, 36, 99, 0.7)",
  },
}));

const BannerTitle = styled(Typography)(({ theme }) => ({
  fontSize: "4rem",
  marginBottom: theme.spacing(1),
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  background: "linear-gradient(to right, #ffd700, #ffffff)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  color: "transparent", // Fallback for browsers that don't support background-clip: text
  [theme.breakpoints.down("md")]: {
    fontSize: "2.5rem",
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "2.5rem",
  marginBottom: theme.spacing(5),
  position: "relative",
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -10,
    left: "50%",
    transform: "translateX(-50%)",
    width: 100,
    height: 4,
    background: "linear-gradient(to right, #ff6b6b, #ffd93d)",
    borderRadius: 2,
  },
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "16px",
  color: "#fff",
  padding: "10px 16px",
  borderRadius: "30px",
  background: "linear-gradient(135deg, #FF6A00, #FF2D55)",
  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  transition: "transform 0.2s ease-in-out, box-shadow 0.2s",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 6px 16px rgba(0,0,0,0.4",
  },
}));

const testimonials = [
  {
    id: 1,
    author: "Elizabeth Thornodrud",
    location: "Norway",
    title: "Consultant for blind and visually impaired",
    text: "It was just incredible to feel how the eyes relaxed, and the contexts of the written words were much easier to comprehend than it usually is when I read screen-based text.",
    avatarInitials: "ET",
  },
  {
    id: 2,
    author: "Howard Traylor",
    location: "Oakland, California",
    title: "Claremont Middle School",
    text: "Readmax has made my students better readers. Students see all phrases and sentences. They are reading and understanding complete thoughts. Students read with more fluency, which makes reading more enjoyable.",
    avatarInitials: "HT",
  },
  {
    id: 3,
    author: "Allson Kadlec",
    location: "University of Minnesota",
    title: "Graduate Student",
    text: "I downloaded Readmax and it was so fast I feel like I must have missed something. Even spookier is that I went to the John Dewey link, opened the text ('How We Think') highlighted the first chapter and it magically appeared there in Readmax format And Dewey isn't as painful to read.",
    avatarInitials: "AK",
  },
  {
    id: 4,
    author: "Dr. Charles Vogel",
    location: "Eagle Valley, Colorado",
    title: "High School teacher",
    text: "I am just blown away with the Shakespeare... All I have to do is open it go to Hamlet and start reading aloud and I have them in my hands... I had SLA kids [saying] 'now I understand!' It's amazing - it opens the door to understanding.",
    avatarInitials: "CV",
  },
  {
    id: 5,
    author: "Janet Elder",
    location: "",
    title: "Author, World-Renowned Reading Specialist",
    text: "I'm intrigued with Readmax because we read and not our eyes When we read, tells the eyes consequently, occur at logical junctures.",
    avatarInitials: "JE",
  },
];

const testimonial = [
  "Lines break at phrase and clause boundaries",
  "Shorter rows of text fit in 1 or 2 fixation spans",
  "Cascading depicts syntactic hierarchies",
  'Row-clusters remain vivid in "mind\'s eye"',
  "Indentations guide the eyes from row to row",
];

const ConferancePage = () => {
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [openQrModal, setOpenQrModal] = useState(false);
  const [openTestimonialModal, setOpenTestimonialModal] = useState(false);
  const [qrLoading, setQrLoading] = useState(true);
  const [videoLoading, setVideoLoading] = useState(true);
  // const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const handleOpenVideoModal = () => {
    setOpenVideoModal(true);
    setVideoLoading(true);
  };
  const handleCloseVideoModal = () => setOpenVideoModal(false);

  const handleOpenQrModal = () => setOpenQrModal(true);
  const handleCloseQrModal = () => setOpenQrModal(false);
  const handleOpenTestimonialModal = () => setOpenTestimonialModal(true);
  const handleCloseTestimonialModal = () => setOpenTestimonialModal(false);

  // const handleNextTestimonial = () => {
  //   setCurrentTestimonialIndex(
  //     (prevIndex) => (prevIndex + 1) % testimonials.length
  //   );
  // };

  // const handlePrevTestimonial = () => {
  //   setCurrentTestimonialIndex(
  //     (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
  //   );
  // };

  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, #0a2463 0%, #1e3a8a 50%, #3b82f6 100%)",
        color: "white",
        lineHeight: 1.6,
        minHeight: "100vh",
      }}
    >
      {/* Banner Section */}
      <BannerBox>
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            maxWidth: 700,
            p: 2,
          }}
        >
          {" "}
          {/* Decreased maxWidth here */}
          <Typography
            variant="h2"
            sx={{
              color: "white",
              fontSize: "2.5rem",
              mb: 2,
              fontWeight: 300,
              "@media (max-width:768px)": { fontSize: "1.8rem" },
            }}
          >
            2025
          </Typography>
          <BannerTitle variant="h1">Reading, Literacy & Learning</BannerTitle>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontSize: "3rem",
              fontWeight: 700,
              // Removed letterSpacing to prevent wrapping
              mb: 3,
              textTransform: "uppercase",
              whiteSpace: "nowrap", // Ensure text stays on one line
              overflow: "hidden", // Hide overflow
              textOverflow: "ellipsis", // Add ellipsis if text overflows
              "@media (max-width:768px)": {
                fontSize: "2rem",
              },
            }}
          >
            ANNUAL IDA CONFERENCE
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 3,
              "@media (max-width:768px)": {
                flexDirection: "column",
                alignItems: "center",
              },
            }}
          >
            <Button
              variant="contained"
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleOpenQrModal}
              sx={{
                padding: "15px 30px",
                borderRadius: "50px",
                fontSize: "1.1rem",
                fontWeight: 600,
                textTransform: "none",
                background: "linear-gradient(45deg, #ff6b6b, #ffd93d)",
                color: "#0a2463",
                boxShadow: "0 4px 15px rgba(255, 107, 107, 0.4)",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 6px 20px rgba(255, 107, 107, 0.6)",
                  background: "linear-gradient(45deg, #ff6b6b, #ffd93d)", // Keep gradient on hover
                },
                "@media (max-width:768px)": {
                  width: "100%",
                  maxWidth: 300,
                },
              }}
            >
              Register Now
            </Button>
            <Button
              variant="outlined"
              startIcon={<PlayCircleFilledWhiteIcon />}
              onClick={handleOpenVideoModal}
              sx={{
                padding: "15px 30px",
                borderRadius: "50px",
                fontSize: "1.1rem",
                fontWeight: 600,
                textTransform: "none",
                background: "rgba(255, 255, 255, 0.2)",
                color: "white",
                border: "2px solid white",
                backdropFilter: "blur(10px)",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.3)",
                  transform: "translateY(-3px)",
                  border: "2px solid white", // Ensure border remains on hover
                },
                "@media (max-width:768px)": {
                  width: "100%",
                  maxWidth: 300,
                },
              }}
            >
              Watch Video
            </Button>
            <Button
              variant="outlined"
              onClick={handleOpenTestimonialModal}
              sx={{
                padding: "15px 30px",
                borderRadius: "50px",
                fontSize: "1.1rem",
                fontWeight: 600,
                textTransform: "none",
                background: "rgba(255, 255, 255, 0.2)",
                color: "white",
                border: "2px solid white",
                backdropFilter: "blur(10px)",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.3)",
                  transform: "translateY(-3px)",
                  border: "2px solid white", // Ensure border remains on hover
                },
                "@media (max-width:768px)": {
                  width: "100%",
                  maxWidth: 300,
                },
              }}
            >
              How it works
            </Button>
          </Box>
        </Box>
      </BannerBox>

      {/* Testimonials Section */}
      <Box sx={{ py: 10, textAlign: "center" }}>
        <Container maxWidth="md">
          <SectionTitle variant="h2" sx={{ color: "white" }}>
            Over{" "}
            <Typography
              component="span"
              variant="inherit"
              sx={{
                backgroundColor: "warning.light",
                color: "warning.contrastText",
                fontWeight: "bold",
                borderRadius: "4px",
                px: 0.5,
              }}
            >
              15 Million
            </Typography>{" "}
            Users have used Readmax to empower themselves through education
          </SectionTitle>

          <Box
            sx={{
              position: "relative",
              mb: 5,
            }}
          >
            {/* Left Award Logo */}
            <Box className="custom-award-left">
              <Typography
                variant="body1"
                sx={{
                  position: "absolute",
                  left: { xs: -60, sm: -80, md: -270 }, // Moved further left
                  top: "12%",
                  transform: "translateY(-50%)",
                  fontWeight: 700,
                  fontSize: 18,
                  width: 200,
                  zIndex: 1,
                  display: { xs: "none", sm: "block" }, // Hide on extra small screens
                }}
                component="p"
              >
                Distinguished Achievement Award.
              </Typography>
              <Box
                component="img"
                src={`${BASEURL}/images/image-1676969445589.png`}
                alt="Logo Left"
                sx={{
                  position: "absolute",
                  left: { xs: -60, sm: -80, md: -250 }, // Moved further left
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: { xs: 110, sm: 130, md: 150 }, // Adjust size
                  height: { xs: 110, sm: 130, md: 150 },
                  borderRadius: "50%",
                  background: "white", // Or a suitable background
                  p: 1, // Padding to make logo smaller inside circle
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                  zIndex: 1,
                  display: { xs: "none", sm: "block" }, // Hide on extra small screens
                }}
              />
            </Box>

            <Slider
              {...{
                dots: true,
                infinite: true,
                speed: 200,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                fade: true,
                autoplaySpeed: 5000,
              }}
            >
              {testimonials.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    maxWidth: 800,
                    mx: "auto",
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "20px",
                    p: 5,
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    position: "relative",
                    flexGrow: 1,

                    "@media (max-width:768px)": {
                      p: "30px 20px",
                      Width: 400,
                    },
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "1.3rem",
                      fontStyle: "italic",
                      mb: 4,
                      lineHeight: 1.8,
                      textAlign: "left",
                      "@media (max-width:768px)": {
                        fontSize: "1.1rem",
                      },
                    }}
                  >
                    {item.text}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 2,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 70,
                        height: 70,
                        background: "linear-gradient(45deg, #ff6b6b, #ffd93d)",
                        fontSize: "1.8rem",
                        color: "#0a2463",
                        fontWeight: "bold",
                      }}
                    >
                      {item.avatarInitials}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h4"
                        sx={{
                          color: "white",
                          fontSize: "1.4rem",
                          mb: 0.5,
                          textAlign: "left",
                        }}
                      >
                        {item.author}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "1rem",
                          opacity: 0.8,
                          textAlign: "left",
                        }}
                      >
                        {`${item.title}, ${item?.location}`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Slider>

            {/* Right Award Logo */}
            <Box className="custom-award-right">
              <Typography
                variant="body1"
                sx={{
                  position: "absolute",
                  right: { xs: -60, sm: -80, md: -280 }, // Moved further left
                  top: "12%",
                  transform: "translateY(-50%)",
                  fontWeight: 700,
                  fontSize: 18,
                  width: 200,
                  zIndex: 1,
                  display: { xs: "none", sm: "block" }, // Hide on extra small screens
                }}
                component="p"
              >
                Innovation Research Award
              </Typography>
              <Box
                component="img"
                src={`${BASEURL}/images/image-1679914991405.png`}
                alt="Logo Right"
                sx={{
                  position: "absolute",
                  right: { xs: -60, sm: -80, md: -250 }, // Moved further right
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: { xs: 110, sm: 130, md: 150 }, // Adjust size
                  height: { xs: 110, sm: 130, md: 150 },
                  borderRadius: "50%",
                  background: "white", // Or a suitable background
                  p: 1, // Padding to make logo smaller inside circle
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                  zIndex: 1,
                  display: { xs: "none", sm: "block" }, // Hide on extra small screens
                }}
              />
            </Box>
          </Box>
          <Box
            component="img"
            src={`${BASEURL}/assets/logo.png`}
            alt="Website Logo"
            sx={{
              position: "absolute",
              bottom: 720,
              right: 10,
              height: 60, // Adjust height as needed
              zIndex: 2, // Ensure logo is above the overlay
              "@media (max-width:768px)": {
                height: 40,
                bottom: 10,
                right: 10,
              },
            }}
          />
        </Container>
        <Box
          sx={{
            mt: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 18,
          }}
        >
          <span>US Patent 10515138</span>
          <span>US Patent 11531804</span>
          <span>US Patent 10650089</span>
        </Box>
      </Box>

      {/* <Box sx={{ p: 4 }}>
        <Button variant="contained" onClick={handleOpenVideoModal}>
          Open Video Modal
        </Button> */}

      <Modal
        open={openVideoModal}
        onClose={handleCloseVideoModal}
        aria-labelledby="video-modal-title"
        aria-describedby="video-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)",
        }}
      >
        <Box
          sx={{
            background: "#1e3a8a",
            p: 0,
            borderRadius: "0px",
            maxWidth: "100vw",
            width: "100vw",
            maxHeight: "100vh",
            height: "100vh",
            position: "relative",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={handleCloseVideoModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              fontSize: 30,
              zIndex: 1,
            }}
          >
            <CloseIcon sx={{ fontSize: "1.5em" }} />
          </IconButton>
          <Box
            sx={{
              position: "relative",
              flexGrow: 1,
              height: "100%",
              width: "100%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {videoLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(0, 0, 0, 0.7)",
                  zIndex: 2,
                }}
              >
                <CircularProgress color="secondary" />
              </Box>
            )}
            {openVideoModal && (
              <video
                src={`${BASEURL}/uploads/welcome_to_readmax_conference.mp4`}
                loop // Added loop attribute for infinite playback
                autoPlay // Added autoplay to start video automatically
                controls // Added controls for user interaction (play/pause, volume, etc.)
                onCanPlay={() => setVideoLoading(false)} // Use onCanPlay for video element to detect when it's ready
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: videoLoading ? "none" : "block",
                  objectFit: "contain", // Ensures the video fits within the player without cropping
                }}
              />
            )}
          </Box>
        </Box>
      </Modal>
      {/* </Box> */}

      {/* QR Code Modal */}
      <Modal
        open={openQrModal}
        onClose={handleCloseQrModal}
        aria-labelledby="qr-modal-title"
        aria-describedby="qr-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)",
        }}
      >
        <Box
          sx={{
            background: "#1e3a8a",
            p: 4,
            borderRadius: "10px",
            maxWidth: { xs: "90vw", sm: 500, md: 600 },
            width: "100%",
            textAlign: "center",
            position: "relative",
            boxShadow: 24,
          }}
        >
          <IconButton
            onClick={handleCloseQrModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              fontSize: 30,
              zIndex: 1,
            }}
          >
            <CloseIcon sx={{ fontSize: "1.5em" }} />
          </IconButton>
          <Typography
            id="qr-modal-title"
            variant="h5"
            component="h2"
            sx={{ mb: 2, color: "white" }}
          >
            Scan to Register
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
              position: "relative",
            }}
          >
            {qrLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(0, 0, 0, 0.7)",
                  borderRadius: "5px",
                  zIndex: 2,
                }}
              >
                <CircularProgress color="secondary" />
              </Box>
            )}
            {openQrModal && ( // Only render image when modal is open
              <img
                src={`${BASEURL}/assets/register_qr.png`}
                alt="QR Code for Registration"
                onLoad={() => setQrLoading(false)} // Set qrLoading to false when image loads
                onError={() => {
                  // Add onError handler
                  console.error("QR Code image failed to load.");
                  setQrLoading(false); // Hide loader even on error
                }}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "5px",
                  opacity: qrLoading ? 0 : 1, // Control visibility with opacity
                  transition: "opacity 0.3s ease-in-out", // Smooth transition
                }}
              />
            )}
          </Box>
          <Typography
            id="qr-modal-description"
            sx={{ mt: 2, color: "white", opacity: 0.8 }}
          >
            Scan this QR code with your phone to proceed to the registration
            page.
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openTestimonialModal}
        onClose={handleCloseTestimonialModal}
        aria-labelledby="qr-modal-title"
        aria-describedby="qr-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)",
        }}
      >
        <Box
          sx={{
            background: "#1e3a8a",
            p: 4,
            borderRadius: "10px",
            maxWidth: { xs: "90vw", sm: 700, md: 800 },
            width: "100%",
            textAlign: "center",
            position: "relative",
            boxShadow: 24,
          }}
        >
          <IconButton
            onClick={handleCloseTestimonialModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              fontSize: 30,
              zIndex: 1,
            }}
          >
            <CloseIcon sx={{ fontSize: "1.5em" }} />
          </IconButton>

          <Typography
            id="qr-modal-title"
            variant="h4"
            component="h2"
            sx={{ mb: 3, color: "white" }}
          >
            How Readmax Enhances Text
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              flexWrap: "wrap",
              mb: 2,
              position: "relative",
            }}
          >
            <Stack
              spacing={2}
              direction="row"
              flexWrap="wrap"
              justifyContent="center"
              alignItems="center"
              gap="6px"
              sx={{
                p: { xs: 2, sm: 4 },
                background: "#0D1B2A",
                borderRadius: "8px",
                width: "100%", // Ensure it takes full width of its parent Box
                boxSizing: "border-box", // Include padding in the width calculation
              }}
            >
              {testimonial.map((text, index) => (
                <StyledChip key={index} label={text} />
              ))}
            </Stack>
          </Box>
        </Box>
      </Modal>

      {/* Footer */}
      {/* <Box
        component="footer"
        sx={{
          textAlign: "center",
          py: 4,
          background: "rgba(0, 0, 0, 0.2)",
          mt: 6,
          fontSize: "0.9rem",
          opacity: 0.8,
        }}
      >
        <Container>
          <Typography variant="body2">
            &copy; 2025 ANNUALIDA Conference. All rights reserved.
          </Typography>
        </Container>
      </Box> */}
    </Box>
  );
};

export default ConferancePage;
